import React from "react";
import ServicePageShell from "../ui/ServicePageShell";
import ServicePageCta from "../ui/ServicePageCta";
import { PrimaryLink } from "../ui/Buttons";
import SeoHead from "../seo/SeoHead";
import PageBreadcrumb from "../seo/PageBreadcrumb";
import Smoke from "../../assets/SmokeTest.jpg";

const SmokeTest = () => {
  return (
    <>
      <SeoHead
        title="Smoke Test Leak Detection in Temecula | Advanced Automotive Smog"
        description="Smoke testing to locate intake, exhaust, and vacuum leaks in Temecula. A fast, accurate way to catch issues early before they lead to bigger repairs."
        path="/services/smoke-test"
      />
      <ServicePageShell>
        <PageBreadcrumb
          label="Smoke Test Service"
          path="/services/smoke-test"
          description="Smoke testing to locate intake, exhaust, and vacuum leaks in Temecula."
          serviceType="Smoke test"
        />
        <div className="flex flex-col gap-10 md:flex-row md:items-center md:gap-14">

          {/* Image Section */}
          <div className="w-full md:w-1/2 flex justify-center order-1 md:order-none">
            <div className="relative w-full max-w-xs sm:max-w-sm">
              <div className="absolute -inset-3 rounded-3xl bg-teal-600/10 blur-xl" />
              <img
                src={Smoke}
                alt="Smoke Test Service"
                className="relative w-full h-auto rounded-3xl border border-slate-200 object-cover shadow-xl"
              />
            </div>
          </div>

          {/* Text Section */}
          <div className="w-full md:w-1/2">
            <div className="mb-4 inline-flex items-center gap-2 rounded-full border border-slate-200 bg-slate-50 px-2.5 py-1 text-[11px] font-medium tracking-normal text-teal-700">
              <span className="h-1.5 w-1.5 rounded-full bg-teal-600" />
              Leak Detection
            </div>

            <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-navy-900 mb-3">
              Smoke Test Service
            </h1>

            <p className="text-sm sm:text-base text-slate-700 mb-6 leading-relaxed">
              Find leaks in your vehicle’s systems quickly and accurately with our
              advanced smoke testing service. Protect your engine and avoid costly
              repairs by catching issues early.
            </p>

            <h2 className="text-lg sm:text-xl font-semibold text-teal-600 mb-2">
              What Is a Smoke Test?
            </h2>

            <p className="text-sm sm:text-base text-slate-700 mb-5 leading-relaxed">
              A smoke test helps diagnose leaks in your intake system, exhaust
              system, vacuum lines, and seals. By gently pushing smoke through the
              system, we can pinpoint leaks that affect performance and efficiency.
              <br />
              <br />
              The test is fast, safe, and one of the most effective methods for
              identifying hidden issues that can cause misfires, rough idling,
              poor gas mileage, and check-engine lights.
            </p>

            <ul className="space-y-2.5 text-sm sm:text-base text-slate-700">
              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                Fast & accurate leak detection
              </li>

              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                Advanced smoke technology for precision diagnostics
              </li>

              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                Detects leaks in intake, exhaust, vacuum lines, and seals
              </li>

              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                Helps prevent engine performance issues
              </li>

              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                Saves money by finding hidden issues early
              </li>
            </ul>

            {/* Button */}
            <div className="mt-8 flex justify-center">
              <PrimaryLink
                to="/contact"
                className="px-10 text-base"
              >
                Book Appointment
              </PrimaryLink>
            </div>
          </div>

        </div>
            <ServicePageCta />
      </ServicePageShell>
    </>
  );
};

export default SmokeTest;
